import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import {
  ApplicationConfig,
  LOCALE_ID,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { appErrorInterceptor } from '@api/errors/interceptors/app-error.interceptor';
import { caseTransformInterceptor } from '@api/http/interceptors/case-transform.interceptor';
import { authInterceptor } from '@authentication/interceptors/auth.interceptor';
import { AuthService } from '@authentication/services/auth.service';
import { NGX_TRANSLATE_PROVIDERS } from '@core/translation/translation.providers';
import { routes } from './app.routes';

registerLocaleData(localeFr);

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    // withComponentInputBinding: routed-component inputs whose names match a route/query param
    // are auto-bound from the URL — beware name collisions.
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([caseTransformInterceptor, appErrorInterceptor, authInterceptor])),
    provideAppInitializer(() => inject(AuthService).restoreSession()),
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    ...NGX_TRANSLATE_PROVIDERS,
  ],
};
